export default {
  title: 'پلن',

  labels: {
    calculateCurrentSubscription: 'محاسبه اعتبار اشتراک فعلی',
    code: 'کد',
    name: 'نام',
    period: 'مدت زمان پلن (براساس ماه)',
    price: 'قیمت ماهیانه',
    free: 'مجانی',
    salePrice: 'قیمت حراج ماهیانه',
    suggestPrice: 'قیمت پیشنهادی',
    category: 'دسته بندی',
    status: 'وضعیت',
    private: 'پلن خصوصی است',
    visibility: 'قابلیت مشاهده',
    renewable: 'تمدید خودکار',
    canAddAddon: 'قابلیت افزودن افزودنی',
    documentLimit: 'محدودیت تعداد سند',
    userLimit: 'محدودیت تعداد کاربر',
    freeTrialDays: 'تعداد روز آزمایشی مجانی',
    product: 'کالا',
    description: 'توضیحات',
    currentPlan: 'فعال',
    showMore: 'مشاهده بیشتر',
    showLess: 'مشاهده کمتر',
    modules: 'ماژول ها',
    delete: 'حذف'
  },

  table: {
    header: {
      row: 'ردیف',
      logo: 'لوگو',
      code: 'کد',
      name: 'نام',
      period: 'دوره',
      price: 'قیمت ماهیانه',
      product: 'محصول',
      category: 'دسته بندی',
      activeApps: 'اپلیکیشن های فعال',
      documentLimit: 'محدودیت اسناد',
      status: 'وضعیت',
      private: 'خصوصی',
      visibility: 'قابل مشاهده',
      delete: 'حذف',
      restore: 'بازگردانی'
    }
  },

  statusTypes: {
    active: 'فعال',
    disable: 'غیرفعال'
  },

  periodTypes: {
    M: 'ماه',
    Y: 'سال'
  },

  wizard: {
    checkout: {
      label: 'Review'
    }
  },

  notifications: {
    wrongInputValue: 'اطلاعات وارد شده صحیح نیست',
    activeAppExist: 'به دلیل وجود اپلیکیشن فعال این پلن قابل حذف نیست',
    subscriptionsExists: 'به دلیل وجود اشتراک این پلن قابل حذف نیست',

    insert: {
      success: 'پلن با موفقیت ایجاد شد',
      error: 'ایجاد پلن با خطا همراه شد'
    },
    edit: {
      success: 'پلن با موفقیت بروزرسانی شد',
      error: 'بروزرسانی پلن با خطا همراه شد'
    },
    delete: {
      success: 'پلن با موفقیت حذف شد',
      error: 'حذف پلن با خطا همراه شد'
    },
    restore: {
      success: 'پلن با موفقیت بازگردانی شد',
      error: 'بازگردانی پلن با خطا همراه شد'
    },
    editLimits: {
      success: 'محدودیت های پلن با موفقیت بروزرسانی شد',
      error: 'بروزرسانی محدودیت های پلن با خطا همراه شد'
    },
    parseError: {
      name: 'نام وارد شده معتبر نیست',
      code: 'کد وارد شده معتبر نیست یا قبلا استفاده شده است'
    }
  },

  validators: {
    permissions: 'دسترسی برای پلن ست نشده است'
  },

  confirmations: {
    delete: {
      title: 'تاییدیه حذف پلن',
      body: 'آیا از حذف پلن مورد نظر اطمینان دارید؟'
    },

    routeBack: {
      title: 'لغو عملیات افزودن پلن',
      body: 'اگر این صفحه را ترک کنید، تمامی اطلاعات وارد شده شما از بین خواهد رفت. آیا از لغو کردن افزودن پلن اطمینان دارید؟'
    }
  },

  list: {
    title: 'پلن ها'
  },

  trash: {
    title: 'سطل زباله پلن'
  },

  insert: {
    title: 'افزودن پلن'
  },

  edit: {
    title: 'ویرایش پلن',
    dynamicTitle: 'ویرایش پلن {name}'
  },

  profile: {
    title: 'پروفایل پلن',
    dynamicTitle: 'پروفایل پلن {name}',

    importantData: {
      code: 'کد',
      price: 'قیمت',
      status: 'وضعیت'
    },

    actions: {
      apps: 'برنامه ها',
      modules: 'ماژول ها',
      addons: 'افزودنی ها',
      logs: 'لیست لاگ ها'
    }
  },

  apps: {
    title: 'لیست برنامه های پلن'
  },

  modules: {
    title: 'ماژول های پلن',

    labels: {
      inMenu: 'منو'
    },

    edit: {
      title: 'ویرایش ماژول های پلن',
      dynamicTitle: 'ویرایش ماژول های پلن {name}'
    }
  },

  addons: {
    title: 'افزودنی های پلن',

    labels: {
      inMenu: 'منو'
    },

    edit: {
      title: 'ویرایش افزودنی های پلن',
      dynamicTitle: 'ویرایش افزودنی های پلن {name}'
    }
  },

  categories:  {
    menu: 'دسته بندی ها',
    title: 'دسته بندی ها',

    general: {
      labels: {
        none: 'هیچ کدام',
        name: 'عنوان',
        slug: 'نامک',
        product: 'محصول',
        description: 'توضیحات',
        withoutCategory: 'بدون دسته بندی',
        productCount: '{count} محصول'
      },

      notifications: {
        parseError: {
          name: 'عنوان معتبر نیست یا قبلا وجود دارد',
          slug: 'نامک معتبر نیست یا قبلا وجود دارد'
        },

        insert: {
          success: 'دسته بندی با موفقیت ایجاد شد',
          error: 'افزودن دسته بندی با خطا همراه شد'
        },
        edit: {
          success: 'دسته بندی با موفقیت ویرایش شد',
          error: 'ویرایش دسته بندی با خطا همراه شد'
        },
        delete: {
          success: 'دسته بندی با موفقیت حذف شد',
          error: 'حذف دسته بندی با خطا همراه شد',
          isUsed: 'این دسته بندی استفاده شده است و قابل حذف نیست'
        }
      },

      validators: {
        attributeExist: 'ویژگی { name } در این دسته بندی وجود دارد',
        noChange: 'هیچ تغییری اعمال نشده است'
      },

      confirmations: {
        delete: {
          title: 'حذف دسته بندی',
          body: 'آیا از حذف  {name} اطمینان دارید؟'
        }
      }
    },

    list: {
      title: 'دسته بندی ها'
    },

    insert: {
      title: 'افزودن دسته بندی جدید'
    },

    edit: {
      title: 'ویرایش دسته بندی'
    }
  },

  logs: {
    title: 'لاگ های پلن'
  }
}
